<!-- append to body -->
<p-toast preventOpenDuplicates="true" position="top-center">
  <ng-template let-message pTemplate="message">
    <div [attr.cy-type]="message?.severity" class="row justify-content-between">
      <div class="col-2">
        <div class="d-flex align-items-center h-100">
          <i [class]="iconConvertor(message?.severity)"></i>
        </div>
      </div>
      <div class="col-10">
        <div class="d-flex flex-column row-gap-2">
          <span [attr.cy-label]="message?.summary">{{message?.summary}}</span>
          <div [attr.cy-label]="message?.detail" [innerHTML]="message.detail"></div>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>

<router-outlet></router-outlet>